export default __webpack_public_path__ + "static/radclimber-5496d0f0d25419663dbeffa466a59257.jpg";